import * as React from 'react';
import {Grid} from '@mui/material';
import { align, position } from '../services/app.service';

interface Props {
  id?: string;
  align?: align;
  position?: position;
  sx?: any,
  children?: React.ReactNode;
}

export const GridContainer: React.FunctionComponent<Props> = (props) => {
  
  return (
    <Grid container alignItems={props.position || 'center'} justifyContent={props.align || 'space-between'} sx={props.sx}>
      {React.Children?.map(props.children, (d: any) => <Grid>{d}</Grid> )}
    </Grid>
  )
  
}